var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { staticClass: "flex f-right" },
        [
          _c(
            "b-button",
            {
              staticClass: "mt-2 blinki-submit-btn",
              attrs: { type: "button", variant: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$bvModal.hide(_vm.modal_name)
                },
              },
            },
            [_vm._v("\n      Fermer\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }